import { isPolygon } from '../isPolygon'
import { isMultiPolygon } from '../isMultiPolygon'

const geoTypes = {
  Polygon: isPolygon,
  MultiPolygon: isMultiPolygon
}

export { geoTypes }
